"use client";
import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const ImageConfigContext = createContext(null);
const ImageConfigProviderClient = ({ children, imageDomainSwapConfig }) => {
  return /* @__PURE__ */ jsx(
    ImageConfigContext.Provider,
    {
      value: {
        imageDomainSwapConfig
      },
      children
    }
  );
};
const useImageConfig = () => {
  const context = useContext(ImageConfigContext);
  if (!context) {
    throw new Error(
      "useImageConfig must be used within a ImageConfigProvider"
    );
  }
  return context;
};
export {
  ImageConfigProviderClient,
  useImageConfig
};
